var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var DashboardController = {
    /*****************************************************************************************************
        * Is using route "api/dashboard" and http method "POST" to call the back-end.
    
        * @param {string[]} types
        * @returns {DashboardDownloadDto[]}
    ******************************************************************************************************/
    GetDashboards: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.types
        });
    },
    /*****************************************************************************************************
        * Is using route "api/dashboard/create" and http method "POST" to call the back-end.
    
        * @param {DashboardUploadDto} dashboard
        * @returns {DashboardDownloadDto}
    ******************************************************************************************************/
    AddDashboard: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/create", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dashboard
        });
    },
    /*****************************************************************************************************
        * Is using route "api/dashboard/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {DashboardUploadDto} dashboard
        * @returns {DashboardDownloadDto}
    ******************************************************************************************************/
    UpdateDashboard: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dashboard
        });
    },
    /*****************************************************************************************************
        * Is using route "api/dashboard/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteDashboard: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/dashboard/elements" and http method "GET" to call the back-end.
    
        * @returns {DashboardElementTemplateDownloadDto[]}
    ******************************************************************************************************/
    GetDashboardElements: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/elements", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/dashboard/forgrouptype/elements" and http method "POST" to call the back-end.
    
        * @param {DashboardElementTemplateFilter} filter
        * @returns {DashboardElementTemplateDownloadDto[]}
    ******************************************************************************************************/
    GetDashboardElementTemplates: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/forgrouptype/elements", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/dashboard/template" and http method "GET" to call the back-end.
    
        * @returns {DashboardTemplateDownloadDto[]}
    ******************************************************************************************************/
    GetDashboardTemplates: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/template", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/dashboard/template" and http method "POST" to call the back-end.
    
        * @param {DashboardTemplateUploadDto} dashboard
        * @returns {DashboardTemplateDownloadDto}
    ******************************************************************************************************/
    AddDashboardTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/template", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dashboard
        });
    },
    /*****************************************************************************************************
        * Is using route "api/dashboard/template/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {DashboardTemplateUploadDto} dashboard
        * @returns {DashboardDownloadDto}
    ******************************************************************************************************/
    UpdateDashboardTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/template/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dashboard
        });
    },
    /*****************************************************************************************************
        * Is using route "api/dashboard/template/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteDashboardTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/dashboard/template/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=DashboardController.js.map